<template>
  <div>
    <ProcessGroup
      :selectedItems="selected_requests"
      type="moveAllPendingRequests"
      @getData="reloadPage"
    />
    <div v-if="!this.$store.state.archiveLoading" style="margin-top: 40px">
      <div v-if="$store.state.views === 'cards'">
        <div v-if="this.$store.state.archiveData.length > 0">
          <RequestsCard
            :CardData="this.$store.state.archiveData"
            v-if="!this.$store.state.archiveLoading"
            @pageCount="handlePageNumber"
            @back="handleBack"
          />
          <div>
            <LoadingMore v-if="loadMoreData" style="margin: 40px" />
          </div>
        </div>
        <div v-else>
          <div>
            <button
              @click="handleBack"
              style="
                width: 70px;
                height: 40px;
                border-radius: 5px;
                margin: 50px;
                color: white;
                background-color: #441545;
                direction: ltr;
              "
            >
              رجوع
            </button>
          </div>
          <div class="noData">لا يوجد بيانات</div>
        </div>
      </div>
      <div v-else-if="$store.state.views === 'table'">
        <table-component
          :showSelect="false"
          itemKey="id"
          :selectedRows.sync="selected_requests"
          :headers="headers"
          :pagination="this.$store.state.pagination"
          :limit="$store.state.counterOfShow"
          :items="this.$store.state.tableData"
          :loading="loading"
          @refresh="getTableData"
          v-model="page"
        >
          <template slot="item.quality_notes" slot-scope="props">
            <span v-if="!props.item.quality_notes"></span>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  props.item.quality_notes.length > 7
                    ? props.item.quality_notes.substring(0, 7) + "..."
                    : props.item.quality_notes
                }}</span>
              </template>
              <div class="font-weight-bold">{{ props.item.quality_notes }}</div>
            </v-tooltip>
          </template>

          <template slot="item.agent_notes" slot-scope="props">
            <span v-if="!props.item.agent_notes"></span>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  props.item.agent_notes.length > 7
                    ? props.item.agent_notes.substring(0, 7) + "..."
                    : props.item.agent_notes
                }}</span>
              </template>
              <div class="font-weight-bold">{{ props.item.agent_notes }}</div>
            </v-tooltip>
          </template>
        </table-component>
      </div>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
      "
      v-else
    >
      <LoadingMore />
    </div>
    <FilterDialogInAdmin pageName="archived" />
  </div>
</template>

<script>
import Axios from "axios";
import RequestsCard from "@/components/Charts/RequestsCard.vue";
import LoadingMore from "@/components/Charts/LoadingMore.vue";
import { formatDate } from "@/mixins/formatDate";
import { SourceValue } from "@/mixins/sourceValue";
import ProcessGroup from "@/views/admin/Requests/MoveToNew/ProcessGroup.vue";
import FilterDialogInAdmin from "@/components/Charts/FilterDialogInAdmin.vue";
import { axiosInstance } from "@/axios/config";


export default {
  name: "AdminSupport",
  components: {
    FilterDialogInAdmin,
    ProcessGroup,
    RequestsCard,
    LoadingMore,
  },

  data() {
    return {
      page: 1,
      selected_products_list: [],
      loading: false,
      copySupportRequests: [],
      loadMoreData: false,
      loadingData: false,
      selected_requests: [],
      ongoingRequest: null,
      responseData: null,
      allGetData: [],
      headers: [
        { text: "تاريخ الطلب", value: "تاريخ الطلب", width: "107px", align: "center" },
        { text: "نوع الطلب", value: "نوع الطلب", align: "center" },
        { text: "نوع المنتج", value: "req_product_type", align: "center" },
        {
          text: "استشاري المبيعات",
          value: "استشاري المبيعات",
          align: "center",
        },
        { text: "عميل", value: "عميل", align: "center" },
        { text: "الجوال", value: "الجوال", align: "center" },
        {
          text: "مصدر المعامله",
          value: "مصدر المعامله",
          width: "120px",
          align: "center",
        },
        {
          text: "تصنيف الاستشاري",
          value: "تصنيف الاستشاري",
          align: "center",
        },
        { text: "الملاحظه", value: "agent_notes", align: "center" },
        {
          text: "ملاحظه الجوده",
          value: "quality_notes",
          align: "center",
        },
        {
          text: "التاريخ الاستشاري",
          value: "التاريخ عند الاستشاري",
          width: "107px",
          align: "center",
        },
        {
          text: "استلام الجودة",
          value: "هل تم استلامه من قبل الجوده",
          align: "center",
        },
        {
          text: "تم التحديث ",
          value: "تم التحديث في",
          width: "108px",
          align: "center",
        },
      ],
    };
  },

  watch: {
    page(val) {
      if (this.$store.state.isSearch === false) {
        this.getTableData(val);
      } else {
        this.searchRequest(val, "table");
      }
    },
    selected_requests(val) {
      this.selectedItems = val;
      this.$emit("requests", val);
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval != oldvalue) {
          this.getTableData(this.page);
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },
  },

  methods: {
    reloadPage() {
      this.$store.state.archiveData = [];
      this.$store.state.tableData = [];
      this.allGetData = [];
      this.copySupportRequests = [];
      this.$store.state.archiveLoading = true;
      this.$store.state.isSearch = false;
      this.page = 1;
      this.getAllRequests(1);
      this.$store.state.startElement = [];
    },
    handleBack() {
      this.$store.state.archiveData = [];
      this.$store.state.tableData = [];
      this.$store.state.archiveLoading = true;
      this.$store.state.isSearch = false;
      this.$store.state.back = false;
      this.getAllRequests(1, "back");
    },
    handlePageNumber(val) {
      if (this.$store.state.isSearch === false) {
        this.getAllRequests(val);
      } else {
        this.searchRequest(val);
      }
    },
    searchRequest(page, type) {
      this.loading = true;

      if (type === "table") {
        this.$store.state.tableData = [];
      }
      if (page > 1 || type === "table") {
        this.$store.state.bodySearch.delete("page");
        this.$store.state.bodySearch.append("page", page);

        const selectedOrderBy =
          this.$store.state.selectedOrderById || "created_at";
        let url = `${this.$store.state.url}/v2/employee/Requests/search?type=archived&order_by=${encodeURIComponent(
          selectedOrderBy
        )}`;
        Axios.post(url, this.$store.state.bodySearch, {
          headers: this.request_headers(),
        }).then((res) => {
          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.searched,
          };
          let response = res.data.payload.data;
          response.map((item) => {
            if (item.length === 0) {
              this.loading = false;
            }
            this.setTbData(item);
            item["starChecked"] = false;
            return item;
          });

          this.$store.state.archiveSearch.push(...response);
          this.removeDublicate(this.$store.state.archiveSearch);
          this.loading = false;
        });
      }
    },

    getTableData(count = 1) {
      this.$store.state.tableData = [];
      this.loading = true;
      const selectedOrderBy =
        this.$store.state.selectedOrderById || "created_at";
      Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=archived&page=${count}&per_page=${this.$store.state.counterOfShow}&order_by=${encodeURIComponent(
          selectedOrderBy
        )}`,
        { headers: this.request_headers() }
      ).then((res) => {
        res.data.payload.data.map((item) => {
          this.setTbData(item);
        });
        this.loading = false;
      });
    },

    setTbData(items) {
      this.$store.state.tableData.push({
        id: items.id,
        "تاريخ الطلب": items.req_date,
        "نوع الطلب": items.type,
        req_product_type: this.selected_products_list.find(item => item.id === items.req_product_type)?.value || "لا_يوجد",
        "استشاري المبيعات": items.user?.name,
        عميل: items.customer?.name,
        الجوال: items.customer?.mobile,
        "مصدر المعامله": SourceValue(items.source),
        "تصنيف الاستشاري": items.class_id_agent_text,
        agent_notes: items.agent_notes,
        quality_notes: items.quality_notes,
        "التاريخ عند الاستشاري": formatDate(items.agent_date),
        "هل تم استلامه من قبل الجوده": this.returnValue(items.highlight_received),
        "تم التحديث في": items.updated_at ? formatDate(items.updated_at) : "",
      });
    },

    returnValue(item) {
      if (!item) {
        return "لا";
      } else {
        return "نعم";
      }
    },

    getAllRequests(count = 1) {
      if (
        this.$store.state.archiveData.length === 0 &&
        this.copySupportRequests.length === 0
      ) {
        this.$store.state.archiveLoading = true;
      }
      this.loadMoreData = true;
      const selectedOrderBy =
        this.$store.state.selectedOrderById || "created_at";
      this.ongoingRequest = Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=archived&page=${count}&per_page=${this.$store.state.counterOfShow}&order_by=${encodeURIComponent(
          selectedOrderBy
        )}`,
        { headers: this.request_headers() }
      )
        .then((res) => {
          this.$store.state.archiveLoading = false;
          let response = res.data.payload.data;
          response.map((item) => {
            this.setTbData(item);
            item["starChecked"] = false;
            return item;
          });

          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.count_of_archived,
          };
          this.allGetData.push(...response);
          this.removeDublicate(this.allGetData);
          this.copySupportRequests.push(...response);
        })
        .catch((err) => {
          this.loadingData = false;
          this.loadMoreData = false;
        })
        .finally(() => {
          this.loadMoreData = false;
          this.loadingData = false;
        });
    },

    removeDublicate(array) {
      let uniqueArray = array.filter((item, index) => {
        return (
          index ===
          array.findIndex((obj) => {
            return obj.id === item.id; // Compare based on the 'id' property
          })
        );
      });
      this.$store.state.archiveData = uniqueArray;
    },

    getProductType() {
      let url = "/customer/SelectedProduct";
      axiosInstance.get(url).then((res) => {
        this.selected_products_list = res.data.payload;
      });
    },
  },

  created() {
    this.$store.state.archiveData = [];
    this.$store.state.tableData = [];
    this.$store.state.back = false;
    this.$store.state.bodySearch = new FormData();
    this.$store.state.isSearch = false;
    this.$store.state.startElement = [];
    this.$store.state.views = "cards";
    this.getProductType();
    this.getAllRequests(1);
    this.selected_products_list = this.$store.state.selected_products;
  },
};
</script>

<style>
.noData {
  display: flex;
  justify-content: center;
  font-size: 22px;
  color: #3f0e40;
  margin-top: 70px;
  font-weight: bold;
}
</style>
